(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ct-youtube-section"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cty-facade[data-vid]').forEach(function(facade) {
    facade.addEventListener('click', function() {
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube.com/embed/' + facade.dataset.vid + '?autoplay=1&rel=0&modestbranding=1';
      iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      facade.innerHTML = '';
      facade.appendChild(iframe);
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pcc-product-card"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  if (window.__pccDone) return;
  window.__pccDone = true;

  function init() {
    var els = document.querySelectorAll('.pcc-host[data-pcc-animate]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('pcc-in'); });
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('pcc-in');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );
    els.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
